package one.healthium.carnivore.di

import org.koin.dsl.module

internal actual fun composeAppPlatformModule() = module {
}